<template>
  <div style="width: 100vw; position: absolute; z-index: 999; bottom: 0%; border-radius: 15px 15px 0 0">
    <div @click="opendrawer" v-show="boxopen" class="drawertop">
      <img src="@/assets/myImg/1/chevron-up-outline.png" class="downicon" />
      <span>展开</span>
    </div>

    <a-drawer placement="bottom" :closable="false" :visible="visible2" :mask="false" :get-container="false"
      :zIndex="999" :width="drawerwidth" :style="{ position: 'absolute' }">
      <div slot="title" style="margin-bottom: 0px">
        <div @click="closedrawer" class="drawertop">
          <img src="@/assets/myImg/1/chevron-down-outline.png" class="downicon" />
          <span>收起</span>
        </div>
      </div>

      <!-- 上方多选框 -->
      <div class="checkboxs">
        <a-checkbox-group style="width: 100%">
          <a-row>
            <a-col :span="8">
              <a-checkbox value="zhukong" :checked="showFamen" @click="jumpFather()">主控阀门</a-checkbox>
            </a-col>
            <a-col :span="8">
              <a-checkbox value="famen" @click="waterPoint('阀门')">影响阀门</a-checkbox>
            </a-col>
            <a-col :span="8">
              <a-checkbox value="hutong" @click="gethutong('互通阀门')">互通阀门</a-checkbox>
            </a-col>
            <a-col :span="8">
              <a-checkbox value="paoshui" @click="getPsfOrXfs(`排水阀`)">排水阀</a-checkbox>
            </a-col>
            <a-col :span="8">
              <a-checkbox value="xiaofang" @click="getPsfOrXfs(`消防栓`)">消防栓</a-checkbox>
            </a-col>
            <a-col :span="8">
              <a-checkbox value="guandao">受影响管道</a-checkbox>
            </a-col>
            <a-col :span="8">
              <a-checkbox value="shuibiao" @click="waterPoint('水表')">影响水表级</a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
        <div class="yingxiangyonghu" @click="checkAffectedUsers">
          <span>
            受影响用户
            <img src="@/assets/myImg/1/chevron-forward-outline.png" class="forwardicon" />
          </span>
        </div>
      </div>

      <div class="bottom">
        <span>附属物</span>
        <!--                 <a-table
                    rowKey="id"
                    :scroll="{ y: 500 }"
                    :data-source="dataList"
                    :columns="columns"
                    :loading="dataListLoading"
                    :pagination="false"
                    size="small"
                >
                    <span slot="action" slot-scope="text, record">
                        <a @click="jumpFather(record, false)" style="color: #fff">展示</a>
                    </span>

                    <span slot="valveLevelAction" slot-scope="text">
                        <a-tag v-if="text" color="blue">{{ text }}级阀门</a-tag>
                    </span>

                    <span slot="statusAction" slot-scope="text, record">
                        <a-button
                            v-if="record.superior"
                            :class="record.selectIndex ? 'selectBtnRed' : 'selectBtn'"
                            :style="{ 'background-color': record.isBlue ? 'blue' : '', 'border-color': record.isBlue ? 'blue' : '' }"
                            type="defalut"
                            @click="onCheckChange(record)"
                        >上级</a-button>
                    </span>
                </a-table>-->
        <a-list :loading="dataListLoading">
          <ul class="tingshuiul">
            <li class="tingshuili" v-for="(item, index) in dataList" :key="index">
              <span class="namespan">{{ item.appendage }}</span>
              <span class="levelspan">{{ item.valveLevel }}级阀门</span>

              <span class="nospan">
                分类编码:{{ item.class_no }}&nbsp;
                <img src="@/assets/myImg/1/copy-outline.png" class="copyicon" />
                <a @click="copyUrl(item.class_no)" style="color: rgba(27, 108, 232, 100)">复制</a>
              </span>
              <span class="checkspan">
                <a-checkbox value="shangji" v-if="item.superior" @click="onCheckChange(item)">上级</a-checkbox>
              </span>

              <a-button class="libutton" @click="jumpFather(item, false)">展示</a-button>
              <!-- <a @click="jumpFather(item, false)" style="color: #fff">展示</a> -->

              <!--                         <a-button
                            v-if="item.superior"
                            :class="item.selectIndex ? 'selectBtnRed' : 'selectBtn'"
                            :style="{ 'background-color': item.isBlue ? 'blue' : '', 'border-color': item.isBlue ? 'blue' : '' }"
                            type="defalut"
                            @click="onCheckChange(item)"
                            >上级</a-button>-->
            </li>
          </ul>
        </a-list>
      </div>
    </a-drawer>
    <!-- 受影响用户 -->
    <affected-users ref="AffectedUsers" v-show="affectshow"></affected-users>
  </div>
</template>

<script>
import { getXfsPsf, getHutong } from '@/api/manage'
import { unByKey } from 'ol/Observable'
import AffectedUsers from './MobileAffectedUsers.vue'
export default {
  name: 'MobileBigMapTubeDrawer',
  components: {
    AffectedUsers
  },
  props: {
    visible2: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    recordId: {
      handler (n, o) {
        this.showDataPoinit2 = !this.showDataPoinit2
      },
      deep: true
    },
    visible2: {
      handler (value) {
        if (!value) {
          this.showDataPoinit2 = false
          this.showShuibiao = false
          this.showZhukong = false
          this.showFamen = false
        } else {
          // 当visible2为true时，清空已加载数据。

          ; (this.dataList = []), (this.waterList = []), (this.alternativeList = []), (this.clickTypeList3 = [])
        }
      },
      deep: true
    }
  },
  data () {
    return {
      boxopen: false,
      colorJump: '',
      colorFamen: '',
      barkID: [],
      colorShuibiao: '',
      showDataPoinit2: false,
      showShuibiao: false,
      showZhukong: false,
      showFamen: false,
      showpaishui: false,
      showhutong: false,
      showxiaofang: false,
      recordId: '0',
      affectshow: false, // 受影响用户显示
      columns: [
        {
          title: '分类编码',
          dataIndex: 'class_no'
        },
        {
          title: '附属物',
          dataIndex: 'appendage'
        },
        {
          title: '阀门级别',
          dataIndex: 'valveLevel',
          scopedSlots: { customRender: 'valveLevelAction' }
        },
        {
          title: '操作',
          // dataIndex: 'action',
          key: 'operation',
          // fixed: 'right',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '',
          dataIndex: 'selectIndex',
          key: 'selectIndex',
          scopedSlots: { customRender: 'statusAction' }
        }
      ],
      dataListLoading: false,
      queryUrl: '/pipe-network/gis/pipe-networks/analysis-of-tube-burst-optimized',
      dataList: [],
      drawerwidth: '90%',
      pipeLineLayerId: '',
      addOrUpdateForm: {},
      waterList: [],
      alternativeList: [],
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 12 },
        sm: { span: 24 }
      }
    }
  },
  computed: {
    rules () {
      return {}
    }
  },
  methods: {
    /**
     * 点击复制方法
     */
    copyUrl (val) {
      // 模拟 输入框
      var cInput = document.createElement('input')
      cInput.value = val

      document.body.appendChild(cInput)
      cInput.select() // 选取文本框内容

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效

      document.execCommand('copy', false)

      this.$message.info('复制成功')
      // 复制成功后再将构造的标签 移除
      document.body.removeChild(cInput)
    },
    gethutong (type) {
      // let id = BigInt(this.dataList[0].id)
      const id = 1473480484499083269n
      console.log(typeof id)

      getHutong(id)
        .then(({ data }) => {
          console.log('互通阀门', data)
          var src = require('@/assets/myImg/1/icon-pipe.png')

          if (this.showhutong) {
            this.$parent.removeLayerByName(type)
            this.showhutong = !this.showhutong
          } else if (!this.showhutong) {
            debugger
            const dataPoinit = []
            const pointValue = []
            let classNumber = ''
            data.forEach((item, index) => {
              dataPoinit.push(JSON.parse(item.geoJson).coordinates)
              pointValue.push(item)
              classNumber += item.class_no + ','
            })
            if (dataPoinit.length > 0) {
              classNumber = classNumber.slice(0, classNumber.length - 1)
              this.$parent.removeLayerByName(type)
              this.$parent.simplePoint(dataPoinit, type, src, pointValue)
              this.showhutong = !this.showhutong
            }
          }
        })
        .catch(() => { })
    },
    getPsfOrXfs (type, indexType) {
      var codes = { appendage: type }
      getXfsPsf(codes)
        .then(({ data }) => {
          console.log('排水阀和消防栓', data)
          var src = {}
          if (type === '排水阀') {
            src = require('@/assets/myImg/1/paishui.png')
          }
          if (type === '消防栓') {
            src = require('@/assets/myImg/1/icon-fire-hydrant.png')
          }
          if (type === '排水阀' && this.showpaishui) {
            this.$parent.removeLayerByName(type)
            this.showpaishui = !this.showpaishui
          } else if (type === '排水阀' && !this.showpaishui) {
            const dataPoinit = []
            const pointValue = []
            let classNumber = ''
            data.list.forEach((item, index) => {
              dataPoinit.push(JSON.parse(item.geoJson).coordinates)
              pointValue.push(item)
              classNumber += item.class_no + ','
            })
            if (dataPoinit.length > 0) {
              classNumber = classNumber.slice(0, classNumber.length - 1)
              this.$parent.removeLayerByName(type)
              this.$parent.simplePoint(dataPoinit, type, src, pointValue)
              this.showpaishui = !this.showpaishui
            }
          }
          if (type === '消防栓' && this.showxiaofang) {
            this.$parent.removeLayerByName(type)
            this.showxiaofang = !this.showxiaofang
          } else if (type === '消防栓' && !this.showxiaofang) {
            const dataPoinit = []
            const pointValue = []
            let classNumber = ''
            data.list.forEach((item, index) => {
              dataPoinit.push(JSON.parse(item.geoJson).coordinates)
              pointValue.push(item)
              classNumber += item.class_no + ','
            })
            if (dataPoinit.length > 0) {
              classNumber = classNumber.slice(0, classNumber.length - 1)
              this.$parent.removeLayerByName(type)
              this.$parent.simplePoint(dataPoinit, type, src, pointValue)
              this.showxiaofang = !this.showxiaofang
            }
          }
          /*                 const dataPoinit = []
                                const pointValue = []
                                let classNumber = ''
                                let src
                                data.list.forEach((item, index) => {
                                    dataPoinit.push(JSON.parse(item.geoJson).coordinates)
                                    pointValue.push(item)
                                    classNumber += item.class_no + ','
                                })
                                if (dataPoinit.length > 0) {
                                    classNumber = classNumber.slice(0, classNumber.length - 1)
                                    this.$parent.removeLayerByName(type)
                                    this.$parent.simplePoint(dataPoinit, type, src, pointValue)
                                } */
        })
        .catch(() => { })
    },
    checkColor () {
      this.colorFamen == 'red' ? this.waterPoint('阀门', 'check') : ''
      this.colorShuibiao == 'red' ? this.waterPoint('水表', 'check') : ''
      this.colorJump == 'red' ? this.jumpFather('', true, true) : ''
    },
    waterPoint (type, indexType) {
      var map = this.$parent.getBigMap()
      var that = this
      var data = []
      var src
      if (type === '水表') {
        this.colorShuibiao = this.colorShuibiao == '' ? 'red' : ''
          ; (data = this.waterList),
            (src = require('@/assets/myImg/1/icon-水表@2x.png')),
            (this.showShuibiao = indexType ? false : !this.showShuibiao)
      }
      if (type === '阀门') {
        this.colorFamen = this.colorFamen == '' ? 'red' : ''
        this.dataList.forEach((item) => {
          if (item.superior !== '上级') {
            data.push(item)
          }
        })
          ; (src = require('@/assets/myImg/1/icon-阀门@2x.png')), (this.showFamen = indexType ? false : !this.showFamen)
      }
      if (type === '水表' && !this.showShuibiao) {
        this.$parent.removeLayerByName(type)
        if (this.clickTypeList3) {
          unByKey(this.clickTypeList3)
        }
      } else if (type === '水表' && this.showShuibiao) {
        this.clickTypeList3 = map.on('click', function (evt) {
          console.log('click=====MobileBigMapTubeDrawer')
          var pixel = map.getEventPixel(evt.originalEvent)
          var feature = map.forEachFeatureAtPixel(pixel, function (feature, layer) {
            that.$parent.addOverLay([0, 0], 'gis_pipe_network', feature.properties)
          })
        })
        const dataPoinit = []
        const pointValue = []
        let classNumber = ''
        data.forEach((item, index) => {
          dataPoinit.push(JSON.parse(item.geoJson).coordinates)
          pointValue.push(item)
          classNumber += item.class_no + ','
        })
        if (dataPoinit.length > 0) {
          classNumber = classNumber.slice(0, classNumber.length - 1)
          this.$parent.simplePoint(dataPoinit, type, src, pointValue)
          this.$parent.influenceLine(classNumber)
        }
      }
      if (type === '阀门' && !this.showFamen) {
        this.$parent.removeLayerByName(type)
        if (this.clickTypeList3) {
          unByKey(this.clickTypeList3)
        }
      } else if (type === '阀门' && this.showFamen) {
        this.clickTypeList3 = map.on('click', function (evt) {
          console.log('click=====MobileBigMapTubeDrawer')
          var pixel = map.getEventPixel(evt.originalEvent)
          var feature = map.forEachFeatureAtPixel(pixel, function (feature, layer) {
            that.$parent.addOverLay([0, 0], 'gis_pipe_network', feature.properties)
          })
        })
        const dataPoinit = []
        const pointValue = []
        let classNumber = ''
        data.forEach((item, index) => {
          dataPoinit.push(JSON.parse(item.geoJson).coordinates)
          pointValue.push(item)
          classNumber += item.class_no + ','
        })
        if (dataPoinit.length > 0) {
          classNumber = classNumber.slice(0, classNumber.length - 1)
          this.$parent.simplePoint(dataPoinit, type, src, pointValue)
          this.$parent.influenceLine(classNumber)
        }
      }
    },
    checkAffectedUsers () {
      const arr = []
      this.waterList.map((item) => {
        return arr.push(item.class_no)
      })
      this.$refs.AffectedUsers.edit(arr.join(','), this.pipeLineLayerId)
      this.affectshow = true
      this.visible2 = false
      this.boxopen = true
      this.$parent.tubeVisible = this.visible2
    },
    jumpAtive () {
      this.checkColor()
      this.dataListLoading = true
      const arr = []
      var that = this
      this.alternativeList = []
      this.dataList.map((item) => {
        if (item.selectIndex == true) {
          arr.push(item.id)
          item.isBlue = true
          this.alternativeList.push(item)
        }
      })
      console.log(this.dataList)
      const params = {
        pipeLineLayerId: this.pipeLineLayerId,
        gisPipeNetworks: arr.join(',')
      }
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          // this.dataList = data.valves
          const list = data.valves
          that.waterList = data.waters
          that.barkID = []
          if (data.classNos) {
            data.classNos.forEach((item) => {
              that.barkID.push(item.class_no)
            })
          }
          if (list) {
            list.map((item) => {
              return (item.selectIndex = false)
            })
            this.dataList = this.alternativeList.concat(list)
            console.log(this.dataList)
          }
        })
        .catch(() => {
          this.dataListLoading = false
        })
      console.log(arr)
    },
    onCheckChange (record) {
      if (record.isBlue) delete record.isBlue
      console.log(123)
      const arr = this.dataList.slice(0)
      const index = arr.findIndex((item) => {
        return item.id == record.id
      })
      arr[index].selectIndex = !arr[index].selectIndex
      this.dataList = arr
      // this.$forceUpdate()
      console.log(this.dataList[index].selectIndex)
    },
    jumpFather (record, isAll = true, indexType) {
      console.log(isAll)
      console.log(12321, record)
      var map = this.$parent.getBigMap()
      var that = this
      console.log('record', record)
      if (this.clickTypeList1) {
        unByKey(this.clickTypeList1)
      }
      this.clickTypeList1 = map.on('click', function (evt) {
        console.log('click=====MobileBigMapTubeDrawer')
        var pixel = map.getEventPixel(evt.originalEvent)
        var feature = map.forEachFeatureAtPixel(pixel, function (feature, layer) {
          that.$parent.addOverLay([0, 0], 'gis_pipe_network', feature.properties)
        })
      })
      if (isAll) {
        this.colorJump = this.colorJump == '' ? 'red' : ''
        this.showZhukong = indexType ? false : !this.showZhukong
        if (!this.showZhukong) {
          this.$parent.removeLayerByName('停水管控')
        } else {
          const dataPoinit = []
          const pointValue = []
          const dataPoinit2 = []
          const pointValue2 = []
          let classNumber = ''
          this.dataList.forEach((item, index) => {
            if (item.superior === '上级') {
              if (this.barkID.indexOf(item.class_no) !== -1) {
                dataPoinit2.push(JSON.parse(item.geoJson).coordinates)
                pointValue2.push(item)
              } else {
                dataPoinit.push(JSON.parse(item.geoJson).coordinates)
                pointValue.push(item)
              }
              classNumber += item.class_no + ','
            }
          })
          if (dataPoinit.length > 0) {
            classNumber = classNumber.slice(0, classNumber.length - 1)
            this.$parent.simplePoint(
              dataPoinit,
              '停水管控',
              require('@/assets/myImg/1/icon-阀门深红@2x.png'),
              pointValue
            )
            this.$parent.simplePoint(
              dataPoinit2,
              '停水管控',
              require('@/assets/myImg/1/icon-阀门灰色@2x.png'),
              pointValue2
            )
            this.$parent.influenceLine(classNumber)
          }
        }
      } else {
        if (this.recordId !== record.id) {
          this.$parent.removeLayerByName('停水管控2')
          this.recordId = record.id
          const dataPoinit2 = []
          dataPoinit2.push(JSON.parse(record.geoJson).coordinates)
          this.$parent.simplePoint(dataPoinit2, '停水管控2', require('@/assets/myImg/1/icon-阀门深红@2x.png'), [record])
          this.showDataPoinit2 = true
        } else {
          this.showDataPoinit2 = !this.showDataPoinit2
          if (!this.showDataPoinit2) {
            const dataPoinit2 = []
            dataPoinit2.push(JSON.parse(record.geoJson).coordinates)
            this.$parent.simplePoint(dataPoinit2, '停水管控2', require('@/assets/myImg/1/icon-阀门深红@2x.png'), [
              record
            ])
          } else {
            this.$parent.removeLayerByName('停水管控2')
          }
        }
      }
    },
    details (id) {
      this.$emit('checkDetails', id)
    },
    check (id) {
      console.log(id, 'llllll')
      if (id) {
        this.getDataList(id)
        this.pipeLineLayerId = id
      }
    },
    getDataList (id) {
      this.alternativeList = []
      this.dataListLoading = true
      const params = {
        pipeLineLayerId: id,
        isPipeNetwork: false
      }
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          this.dataList = data.valves
          this.waterList = data.waters
          if (this.dataList) {
            this.dataList.map((item) => {
              return (item.selectIndex = false)
            })
          }

          console.log(this.dataList)
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    closedrawer () {
      this.visible2 = false
      this.boxopen = true
      this.$parent.tubeVisible = this.visible2
    },
    opendrawer () {
      // this.visible2=true;
      this.boxopen = false
      this.$parent.tubeAnalysis() // 修改监听，停水管控抽屉清空
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-drawer-content-wrapper {
  /*  background: rgb(236,237,241); */
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
  height: 50vh !important;
  border-radius: 15px 15px 0 0;
}

/deep/ .ant-drawer-wrapper-body {
  background: rgb(236, 237, 241);
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);
}

/deep/ .ant-drawer-header {
  background: rgb(236, 237, 241);
  border-bottom: 0px solid #e8e8e8;
}

/deep/ .ant-drawer-header {
  background-color: rgb(236, 237, 241);
  padding: 0;
}

.drawertop {
  background-color: rgb(236, 237, 241);
  /* background-color:#0086ff; */
  z-index: 9999;
  height: 4vh;
  line-height: 4vh;
  text-align: center;
  border-radius: 15px 15px 0 0;
  color: rgb(51, 136, 249);

  span {
    font-size: 16px;
  }

  .downicon {
    width: 15px;
    height: 15px;
  }
}

.checkboxs {
  background-color: #fff;
  padding: 8px;
  font-size: 10px;
  border-radius: 15px;
  height: 20vh;

  /deep/ .ant-checkbox-group {
    line-height: 4vh;
  }

  .yingxiangyonghu {
    margin-top: 0.8vh;
    height: 4vh;
    background-color: rgb(234, 243, 254);
    position: relative;

    span {
      color: rgb(51, 136, 249);
      line-height: 4vh;
      font-size: 14px;
      padding-left: 3vw;
      text-align: center;

      .forwardicon {
        width: 15px;
        height: 15px;
        position: absolute;
        right: 1vw;
        top: 1vh;
      }
    }
  }
}

.bottom {
  margin-top: 1vh;
  width: 100%;

  .tingshuiul {
    padding: 1%;
    width: 100%;

    .tingshuili {
      list-style: none;
      background-color: #fff;
      height: 9vh;
      margin-top: 1vh;
      padding: 1%;
      width: 100%;
      position: relative;
      border-radius: 8px;
    }

    .namespan {
      font-size: 18px;
      font-weight: bolder;
      position: absolute;
      left: 1vw;
    }

    .levelspan {
      position: absolute;
      padding: 3px;
      left: 12vw;
      background-color: rgb(234, 243, 254);
      color: #0086ff;
    }

    .nospan {
      position: absolute;
      top: 5vh;

      .copyicon {
        width: 15px;
        height: 15px;
        color: rgb(27, 108, 232);
      }
    }

    .checkspan {
      position: absolute;
      left: 30vw;
    }

    .libutton {
      position: absolute;
      right: 3vh;
      top: 2.5vh;
    }
  }
}

.selectBtnRed {
  color: white;
  background-color: red;
  border-color: red;
}

.selectBtn {
  color: black;
  background-color: white;
  border-color: white;
}

/deep/ .ant-drawer-body {
  padding: 8px;
}

/deep/ .ant-drawer-content {
  border-radius: 15px 15px 0 0;
}
</style>
